import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "tidy-card-select",
    styleUrls: ['./tidy-card-select.directive.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
  <div class="tidy-form tidy-container">
    <div class="tidy-item icon-align">
      <ng-content select="[item-left]"></ng-content>
    </div>
    <div class="tidy-bottom-border">
      <div class="tidy-item">
        <ng-content select="[item-label]"></ng-content>
      </div>
      <div class="tidy-item">
        <ng-content select="[item-right]"></ng-content>
      </div>
    </div>
  </div>
  `,
    standalone: false
})
export class TidyCardSelect {}
